var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"vl",staticClass:"value",style:({color : _vm.color}),attrs:{"contentEditable":_vm.editable},on:{"keypress":_vm.onKeypress,"blur":_vm.blur,"focus":_vm.focus}},[_vm._v(_vm._s(_vm.formattedFocused))])}
var staticRenderFns = []

export { render, staticRenderFns }